export const searchResultsQuantity = 3;
export const minSearchPhraseLength = 3;
